(function () {
  var HOST_SELECTORS = [
    ".gw-rd-ways-to-earn-page-widget-placeholder",
    ".gw-rd-ways-to-spend-page-widget-placeholder",
    ".gw-rd-history-page-widget-placeholder",
  ];

  // Selector used to discover which Growave "Ways to earn" tiles the
  // theme wants to hide.
  //
  // The Visual Ways To Earn section (visual-ways-to-earn-jkl.liquid)
  // emits data-growave-mission-id on each earning_card whose merchant
  // filled the "Growave mission ID" block setting. Those values are
  // exact matches of Growave's data-gw-selector attribute
  // (e.g. "gw-ways-to-earn-page-widget-70074").
  //
  // By reading them at runtime we avoid hardcoding a list of IDs here
  // — merchant can add/remove survey tiles in the theme editor and
  // the hide behaviour follows automatically.
  var MISSION_ID_SELECTOR = "[data-growave-mission-id]";

  var cssText =
    ".gw-rd-page-widget-customer-balance{display:none !important;}" +
    "h2.gw-rd-page-widget-title{display:none !important;}" +
    "div.gw-rd-page-widget-card__icon{width:120px!important;height:150px!important;background-color:transparent!important;border-radius: 0 !important;}" +
    ".gw-rd-ways-to-spend-page-widget .gw-rd-page-widget-card__icon{width:140px!important;height:100px!important;background-color:transparent!important;border-radius: 0 !important;}" +
    ".gw-rd-ways-to-spend-page-widget .gw-rd-page-widget-card--free-product-rule{width:150px!important;}" +
    ".gw-rd-page-widget-card{border: 2px solid #BBC0D2 !important;}" +
    ".gw-rd-ways-to-spend-page-widget .gw-rd-page-widget-card{padding: 40px 24px 24px 24px !important;}" +
    ".rewards-general-theme .gw-rd-page-widget-title{display:none!important;}";

  function injectStyle(shadowRoot) {
    if (!shadowRoot) return;

    var style = shadowRoot.querySelector('style[data-gw-custom="1"]');
    if (!style) {
      style = document.createElement("style");
      style.setAttribute("data-gw-custom", "1");
      shadowRoot.appendChild(style);
    }

    style.textContent = cssText;
  }

  // Collect Growave mission IDs the theme wants hidden.
  // Reads the data-growave-mission-id attribute of every earning_card
  // block on the current page. Ignores empty values (blocks where the
  // merchant did not fill the setting).
  //
  // Returns a Set for O(1) lookup inside hideSurveyTiles.
  function collectHiddenMissionIds() {
    var ids = new Set();
    document.querySelectorAll(MISSION_ID_SELECTOR).forEach(function (el) {
      var id = (el.getAttribute("data-growave-mission-id") || "").trim();
      if (id) ids.add(id);
    });
    return ids;
  }

  // Hide Growave-generated tiles whose data-gw-selector matches one
  // of the IDs collected from the theme. Idempotent — safe to run
  // multiple times as MutationObserver fires.
  function hideSurveyTiles(shadowRoot, hiddenIds) {
    if (!shadowRoot || !hiddenIds || hiddenIds.size === 0) return;

    var cards = shadowRoot.querySelectorAll(".gw-rd-page-widget-card");
    cards.forEach(function (card) {
      // Skip cards we already processed (avoid re-reading the DOM on
      // every mutation once we've hidden a tile).
      if (card.getAttribute("data-jkl-survey-hidden") === "1") return;

      var gwId = (card.getAttribute("data-gw-selector") || "").trim();
      if (!gwId || !hiddenIds.has(gwId)) return;

      // Use style.display + marker attribute so subsequent scans skip
      // this card, and so a manual style change in DevTools can revert
      // it during debugging.
      card.style.display = "none";
      card.setAttribute("data-jkl-survey-hidden", "1");
    });
  }

  function collectShadowRoots(startEl) {
    var roots = new Set();
    var seen = new Set();

    function walk(el) {
      if (!el || seen.has(el)) return;
      seen.add(el);

      if (el.shadowRoot) {
        roots.add(el.shadowRoot);
        el.shadowRoot.querySelectorAll("*").forEach(walk);
      }

      el.querySelectorAll("*").forEach(function (child) {
        if (seen.has(child)) return;
        if (child.shadowRoot) {
          roots.add(child.shadowRoot);
          child.shadowRoot.querySelectorAll("*").forEach(walk);
        }
      });
    }

    walk(startEl);
    return Array.from(roots);
  }

  function applyToHost(host, hiddenIds) {
    var roots = collectShadowRoots(host);
    if (!roots.length) return false;
    roots.forEach(function (root) {
      injectStyle(root);
      hideSurveyTiles(root, hiddenIds);
    });
    return true;
  }

  function tryApplyAll() {
    // Rebuild the hidden-IDs set on every pass so tiles added/removed
    // via the theme editor take effect without a full page reload.
    var hiddenIds = collectHiddenMissionIds();
    var any = false;

    HOST_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (host) {
        if (applyToHost(host, hiddenIds)) any = true;
      });
    });

    return any;
  }

  var mo = new MutationObserver(function () {
    tryApplyAll();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
  tryApplyAll();
})();
